<template>
  <transition name="modal">
    <div class="custom-modal" :id="getId" @click="handleOutsideClick($event)" v-if="showModal">
      <transition name="modal-content">
        <div id="modal-content" :style="{ width: width + 'px' }" class="custom-modal-content">
          <div v-if="arrowTitle" class="modal-heading" :class="{ title: title }">
            <img src="@/assets/images/icons/back-icon.svg" alt=""><span class="mx-2 text-muted">|</span>
            <h1 class="my-auto">{{ title }}</h1>

          </div>
          <div v-else class="modal-heading" :class="{ title: title }">
            <h1>{{ title }}</h1>
            <!-- <h1 class="cursor-pointer" @click="closeModal"><svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="red" d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z" />
</svg></h1> -->
          </div>
          <slot></slot>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    arrowTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    width: {
      type: String,
      required: false,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    getId() {
      if (this.id) {
        return "modal-" + this.id;
      }
      return "modal";
    },
  },
  methods: {
    closeModal() {
      // alert(this.getId)
      this.$emit("close-modal", this.getId);
    },
    handleOutsideClick(event) {
      let modal = document.getElementById(this.getId);
      if (event.target == modal) {
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped>
.custom-modal {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: scroll;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease 0.5s;
  /* padding: 30% 0; */
}

/* Modal Content/Box */
.custom-modal-content {
  background-color: #ffffff;
  padding: 1.5rem;
  border: 1px solid #888;
  width: 40%;
  max-height: 90%;
  border-radius: 6px;
  overflow-y: scroll;
}

.custom-modal-content::-webkit-scrollbar {
  width: 1rem;
}

.custom-modal-content::-webkit-scrollbar-thumb {
  background-color: rgb(182, 182, 182);
  border-radius: 5px;
}

.modal-heading {
  display: flex;
  /* justify-content: space-between; */
  padding-bottom: 1rem;
}

.modal-heading.title {
  /* border-bottom: 0.2px solid #a3a4a7; */
}

.modal-heading h1 {
  font-weight: bold;
  font-size: 1rem;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.modal-enter-to,
.modal-leave {
  opacity: 1;
  transform: translateY(0);
}

.modal-enter-active,
.modal-leave-active {
  transition: all ease 0.5s;
}

@media screen and (max-width: 768px) {
  .custom-modal-content {
    width: 100% !important;
    padding: 0.5rem;
  }
}
</style>
